<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Monthly Tests",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Multiselect,
  },
  data() {
    return {
      title: "Monthly Assessement Tests",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Monthly Assessment",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "test.name",
          label: "Set Name",
          sortable: true,
        },
        {
          key: "class_details.name",
          label: "Class",
          sortable: true,
        },
        {
          key: "month",
          label: "Month",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        test: "",
        classes: [],
        month: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        name: "",
        test: "",
        month: "",
        id: "",
      },
      monthsArray: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      classError: "",
      testError: "",
      modal: "",
      minMonth: "",
    };
  },
  computed: {
    ...mapGetters("coursework", ["OtherSets", "MonthlyTests", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("classes", ["AllClasses"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.MonthlyTests ? this.MonthlyTests.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.MonthlyTests ? this.MonthlyTests.length : 1;
  },
  methods: {
    ...mapActions({
      FetchMonthlyTests: "coursework/fetchMonthlyTests",
      FetchOtherSets: "coursework/fetchOtherSets",
      AddMonthlyTest: "coursework/addMonthlyTests",
      DeleteMonthlyTest: "coursework/deleteMonthlyTest",
      FetchClasses: "classes/fetchClasses",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.MonthlyTests ? this.MonthlyTests.length : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
    },

    resetAddModal() {
      this.data = {
        classes: [],
        test: "",
        month: 0,
      };
      this.resetError();
      this.setYear();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },

    addSet(modal) {
      this.modal = modal;
      this.AddMonthlyTest(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.test.name;
    },
    deleteSet(modal) {
      this.modal = modal;
      this.DeleteMonthlyTest(this.deletedata);
      this.closeModal(modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    setCurrentMonth() {
      // Get the current date
      const currentDate = new Date();
      const cYear = currentDate.getFullYear();
      const cMonth = parseInt(currentDate.getMonth()) + 1;
      const month = cMonth > 9 ? "-" + cMonth : "-0" + cMonth;

      this.minMonth = this.data.month = cYear + month;
    },
  },
  created() {
    this.FetchOtherSets();
    this.FetchMonthlyTests();
    this.FetchClasses();
    this.setCurrentMonth();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_consided_tests')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  List of Monthly Assessment Tests.
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-set-modal
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_consided_tests')
                    )
                  "
                  class="btn btn-sm btn-primary float-end"
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="MonthlyTests"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(month)="data">
                  {{ monthsArray[data.item.month - 1] }}
                </template>
                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-set-modal
                    v-if="
                      getCurrentUser.permissions.find((item) =>
                        item.permission.includes('delete_consided_tests')
                      )
                    "
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-set-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_consided_tests')
          )
        "
      >
        <template #modal-title> Add New Set </template>
        <div class="row d-flex">
          <div class="col-md-10 mx-auto">
            <div class="form-group mb-2">
              <label>Test Set <small class="text-danger">*</small></label>
              <div class="input-group">
                <model-list-select
                  :list="OtherSets ? OtherSets : []"
                  v-model="data.test"
                  option-value="id"
                  option-text="name"
                  class="mb-3"
                  placeholder="Select Set"
                  @input="resetError()"
                >
                </model-list-select>
              </div>
              <div class="text-danger" v-if="testError">
                <em>{{ testError }}</em>
              </div>
            </div>
            <div class="form-group mb-2">
              <label>Test Month <small class="text-danger">*</small></label>
              <div class="input-group">
                <input
                  type="month"
                  v-model="data.month"
                  :min="minMonth"
                  class="form-control"
                />
              </div>
            </div>
            <div class="form-group mb-2">
              <label>Class(es) <small class="text-danger">*</small></label>
              <div class="input-group">
                <multiselect
                  v-model="data.classes"
                  :height="300"
                  :options="AllClasses ? AllClasses : []"
                  :multiple="true"
                  :taggable="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  tag-placeholder="Add a class"
                  placeholder="Search or add a class"
                  label="name"
                  track-by="id"
                  :preselect-first="false"
                >
                  <template slot="selection" slot-scope="{ values, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length &amp;&amp; !isOpen"
                      >{{ values.length }} options selected</span
                    ></template
                  >
                </multiselect>
              </div>
              <div class="text-danger" v-if="classError">
                <em>{{ classError }}</em>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-set-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="addSet('add-set-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete set starts -->
      <b-modal
        id="delete-set-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_consided_tests')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Test Set {{ deletedata.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Test Set From considered sets? Click Confirm
              Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-set-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="deleteSet('delete-set-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
